export const I18N_VERSION = '1caff5e68d06';
